module.exports = __webpack_public_path__ + "img/深谷光科技.8a4f4c57.png";